import { useEffect } from 'react';
const getRenderFunc = useRecaptchaEnterprise => useRecaptchaEnterprise ? window.grecaptcha.enterprise.render : window.grecaptcha.render;
const loadScript = _ref => {
  let {
    sitekey,
    onLoad,
    onSuccess,
    onExpired,
    onFailure,
    locale,
    useRecaptchaEnterprise,
    baseUrl
  } = _ref;
  window.hsRecaptchaLoaded = () => {
    const widgetId = getRenderFunc(useRecaptchaEnterprise)('hsRecaptchaTarget', {
      sitekey,
      callback: onSuccess,
      'expired-callback': onExpired,
      'error-callback': onFailure,
      size: 'invisible',
      badge: 'inline'
    }, true);
    onLoad(widgetId);
  };
  const script = document.createElement('script');
  const path = useRecaptchaEnterprise ? 'enterprise' : 'api';
  script.async = true;
  script.defer = true;
  script.id = 'recaptcha';
  script.onerror = function (error) {
    throw error;
  };
  script.src = `${baseUrl}/${path}.js?&onload=hsRecaptchaLoaded&render=explicit&hl=${locale}`;
  script.type = 'text/javascript';
  document.body.appendChild(script);
};
export default (_ref2 => {
  let {
    onLoad,
    onSuccess,
    sitekey,
    locale,
    onExpired,
    onFailure,
    useRecaptchaEnterprise,
    baseUrl
  } = _ref2;
  useEffect(() => {
    loadScript({
      sitekey,
      onLoad,
      onSuccess,
      locale,
      onExpired,
      onFailure,
      useRecaptchaEnterprise,
      baseUrl
    });
  }, [sitekey, onLoad, onSuccess, locale, onExpired, onFailure, useRecaptchaEnterprise, baseUrl]);
});